export default [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/samo/templates/HotelList.vue'),
        meta: { access: 'auth', title: 'routes.core.dashboard' },
    },
    {
        path: '/account/login',
        name: 'login',
        component: () => import('@/views/account/login.vue'),
        meta: { access: 'guest', title: 'routes.core.login' }
    },
    {
        path: '/auth/reset-password',
        name: 'ResetPassword',
        component: () => import('@/views/account/reset-password.vue'),
        meta: { public: true, title: 'routes.core.reset_password' },
    },
    {
        path: '/account/register',
        name: 'register',
        component: () => import('@/views/account/register.vue'),
        meta: { access: 'guest', title: 'routes.core.register' }
    },
    {
        path: '/invite/:token?',
        name: 'invite-accept',
        component: () => import('@/views/account/InviteAccept.vue'),
        meta: { access: 'guest' },
    },
];